export function TextBlock({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.50848 2.4165H13.4919C14.8594 2.41654 15.8606 2.82147 16.5182 3.47998C17.1347 4.09727 17.5275 5.01549 17.571 6.25439L17.5749 6.50635V13.4917C17.5749 14.8589 17.1702 15.8601 16.5114 16.519C15.8525 17.178 14.8506 17.5835 13.4831 17.5835H6.50848C5.14123 17.5835 4.13999 17.1785 3.48114 16.519C2.82219 15.8593 2.41669 14.8551 2.41669 13.4829V6.5083C2.41669 5.14079 2.82123 4.13892 3.48016 3.47998C4.1391 2.82104 5.14097 2.4165 6.50848 2.4165ZM14.777 6.17041C11.8761 4.72001 8.43162 4.67481 5.49677 6.03467L5.21454 6.17041L5.2077 6.17432C4.54174 6.51629 4.25834 7.33446 4.60419 8.01807V8.01904C4.84808 8.50647 5.34412 8.7749 5.83368 8.7749C6.01082 8.77486 6.22057 8.74295 6.42743 8.64893L6.4411 8.64307L6.4538 8.63623C7.13998 8.29035 7.87158 8.05794 8.62469 7.9292V13.5747C8.62469 14.3305 9.24396 14.9495 9.99969 14.9497C10.7556 14.9497 11.3747 14.3306 11.3747 13.5747V7.9292C12.0007 8.03616 12.6116 8.2144 13.194 8.47021L13.5456 8.63623L13.5544 8.64014L13.5622 8.64404C14.2006 8.94645 14.9475 8.72723 15.322 8.14697L15.3923 8.02588C15.724 7.37994 15.4912 6.61334 14.9001 6.23975L14.777 6.17041Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
